import { render, staticRenderFns } from "./manualsView.vue?vue&type=template&id=4f2259ce&scoped=true&"
import script from "./manualsView.vue?vue&type=script&lang=js&"
export * from "./manualsView.vue?vue&type=script&lang=js&"
import style0 from "./manualsView.vue?vue&type=style&index=0&id=4f2259ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2259ce",
  null
  
)

export default component.exports